module.exports = __webpack_public_path__ + "static/marty-icon-79a3c18bde8ba18bc57fb78b613855cc.png";